import type OpenAI from "openai";

export type OpenaiToolWithPromptCacheLoading = OpenAI.Responses.FunctionTool & {
  defer_loading: boolean;
};

/**
 * Marks whether an OpenAI tool stays in the cached prefix.
 *
 * `includeInPromptCache` keeps the tool eager: `defer_loading: false`, no namespace. Every other
 * tool is deferred. The server places deferred tools in the `page_controls` namespace.
 *
 * @param tool converted OpenAI function tool
 * @param includeInPromptCache from `registerTool` options; unset means deferred
 */
export const withPromptCacheToolLoading = (
  tool: OpenAI.Responses.FunctionTool,
  includeInPromptCache = false
): OpenaiToolWithPromptCacheLoading => {
  return { ...tool, defer_loading: !includeInPromptCache };
};
